// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import SrSearch from './SrSearch/index'
import SrTable from './SrTable/index'
import SrAdd from './SrAdd/index'
import SrNumber from "./SrNumber/index"
import SrSelect from "./SrSelect/index"
import SrSwitch from "./SrSwitch/index"
import SrInput from "./SrInput/index"
import SrUpload from "./SrUpload/index"
import SrEditor from './SrEditor/index'
import SrView from "./SrView/index"
import SrTextarea from "./SrTextarea/index"
import SrCheckbox from "./SrCheckbox/index"
import SrDatetime from "./SrDatetime/index"
import SrDatePicker from "./SrDatePicker/index"
import SrFile from './SrFile/index'
import SrTraceTrack from "./SrTraceTrack/index"
import SrDialogSelect from './SrDialogSelect/index'
import SrEditTable from './SrEditTable/index'
import SrBigUpload from "./SrBigUpload/index"
import SrText from "./SrText/index"
import SrRadio from "./SrRadio/index"
import SrPannel from "./SrPannel/index"
import SrDialog from "./SrDialog/index"
import SrMoreText from "./SrMoreText/index"
import SrKindEditor from "./SrKindEditor/index"
import SrSettingTable from "./SrSettingTable/index"
import SrQiankunAdd from "./SrQiankunAdd/index"
import SrQiankunView from "./SrQiankunView/index"
import SrAlert from "./SrAlert/index"
import SrMessage from "./SrMessage"
import SrPopover from "./SrPopover/index"
import SrMultipleText from "./SrMultipleText/index"
import SrNavPage from "./SrNavPage/index"
import SrQiankunWorkFlow from "./SrQiankunWorkFlow/index"
import SrUtils from './SrUtils/index.js'
import SrDirectives from './SrDirectives/index.js'
import SrSelectPeople from './SrSelectPeople/index.js'
import SrDuration from './SrDuration/index.js'
import SrTag from './SrTag/index.js'
import SrStep from './SrStep/index.js'
import SrSupplementBox from "./SrSupplementBox/index.js"
import SrDInput from "./SrDInput/index.js"
import SrProcess from "./SrProcess/index.js"
import SrProcessItem from "./SrProcessItem/index.js"
import SrDialogAddOptions from "./SrDialogAddOptions/index";
import SrSubTitle from "./SrSubTitle/index";
// import SrGstc from "./SrGstc/index.js";
// import { GSTC } from "./SrGstc/index.vue";

const components = [
  SrSearch,
  SrAdd,
  SrNumber,
  SrSelect,
  SrInput,
  SrSwitch,
  SrUpload,
  SrTable,
  SrEditor,
  SrView,
  SrTextarea,
  SrCheckbox,
  SrDatetime,
  SrTraceTrack,
  SrDatePicker,
  SrFile,
  SrDialogSelect,
  SrEditTable,
  SrBigUpload,
  SrText,
  SrRadio,
  SrPannel,
  SrDialog,
  SrMoreText,
  SrKindEditor,
  SrSettingTable,
  SrQiankunAdd,
  SrQiankunView,
  SrAlert,
  SrMessage,
  SrPopover,
  SrMultipleText,
  SrNavPage,
  SrQiankunWorkFlow,
  SrSelectPeople,
  SrDuration,
  SrTag,
  SrStep,
  SrSupplementBox,
  SrDInput,
  SrDialogAddOptions,
  SrSubTitle,
  SrProcess,
  SrProcessItem
  // SrGstc
];

const install = function (Vue) {
  // Vue.use(ElementUI)
  Vue.use(SrDirectives)
  Vue.prototype.$SrUtils = SrUtils
  // window.$GSTC = GSTC;
  // Vue.prototype.$GSTC = GSTC
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  SrSearch,
  SrAdd,
  SrNumber,
  SrSelect,
  SrSwitch,
  SrInput,
  SrUpload,
  SrTable,
  SrEditor,
  SrView,
  SrTextarea,
  SrCheckbox,
  SrDatetime,
  SrDatePicker,
  SrFile,
  SrTraceTrack,
  SrDialogSelect,
  SrEditTable,
  SrBigUpload,
  SrText,
  SrRadio,
  SrPannel,
  SrDialog,
  SrSettingTable,
  SrMoreText,
  SrKindEditor,
  SrAlert,
  SrMessage,
  SrPopover,
  SrMultipleText,
  SrNavPage,
  SrQiankunWorkFlow,
  SrSelectPeople,
  SrDuration,
  SrTag,
  SrStep,
  SrSupplementBox,
  SrDInput,
  SrDialogAddOptions,
  SrSubTitle,
  SrProcess,
  SrProcessItem
  // SrGstc
};

// export {
//   GSTC
// }


// WEBPACK FOOTER //
// ./packages/index.js